import React from "react";
import styled from "styled-components";

const StyledImage = styled.img`
  display: block;
`;

export const Image = React.memo(({ src, alt, className, loading = "lazy", ...props }) => (
  <StyledImage
    src={src}
    alt={alt}
    className={className}
    loading={loading}
    decoding="async"
    {...props}
  />
));
